import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { print } from 'graphql';
import { GraphQLClient } from 'graphql-request';

export interface GraphQLRequestArgs<Result, Variables> {
  url: string;
  document: TypedDocumentNode<Result, Variables>;
  variables?: Variables;
  headers?: HeadersInit;
}

/**
 * Sends a GraphQL request to the specified URL using the given document and variables.
 * By default, it retrieves the auth0 access token and includes it in the Authorization header of the request.
 */
export default async function requestGraphQL<Result, Variables extends object | undefined>({
  url,
  document,
  variables,
  headers,
}: GraphQLRequestArgs<Result, Variables>) {
  const graphqlRequestClient = new GraphQLClient(url);

  const response = await graphqlRequestClient.rawRequest<Result>({
    query: print(document),
    variables,
    requestHeaders: headers,
  });
  return response.data;
}
